import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260318_viewport_preset_id_fallback",
  description: "Set presetId and optionSetOverrides defaults on viewports and dataTables",
  apply(json: any) {
    for (const id in json.viewports ?? {}) {
      const viewport = json.viewports[id];

      if (viewport.presetId === undefined) {
        viewport.presetId = { type: "PARAMETER_REF", id: "activeOptionState" };
      }

      if (viewport.optionSetOverrides === undefined) {
        viewport.optionSetOverrides = {};
      }
    }

    for (const id in json.dataTables ?? {}) {
      const dataTable = json.dataTables[id];

      if (dataTable.presetId === undefined) {
        dataTable.presetId = { type: "PARAMETER_REF", id: "activeOptionState" };
      }

      if (dataTable.optionSetOverrides === undefined) {
        dataTable.optionSetOverrides = {};
      }
    }

    return json;
  },
};

export default migration;
